webpackJsonp([114276838955818,60335399758886],{

/***/ 103:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(182);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(103);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(96);
	var isArguments = __webpack_require__(95);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(110);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(94);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(108);
	
	var _HelmetConstants = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(63);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(98));
	var shallowEqual = _interopDefault(__webpack_require__(114));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/apple-touch-icon.d230e92b.png";

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.02674b92.ico";

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.safariPinnedTab = exports.icoFormat = exports.size32 = exports.size16 = exports.appleTouch = undefined;
	
	var _appleTouchIcon = __webpack_require__(496);
	
	var _appleTouchIcon2 = _interopRequireDefault(_appleTouchIcon);
	
	var _favicon16x = __webpack_require__(497);
	
	var _favicon16x2 = _interopRequireDefault(_favicon16x);
	
	var _favicon32x = __webpack_require__(498);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	var _favicon = __webpack_require__(316);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _safariPinnedTab = __webpack_require__(499);
	
	var _safariPinnedTab2 = _interopRequireDefault(_safariPinnedTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.appleTouch = _appleTouchIcon2.default;
	exports.size16 = _favicon16x2.default;
	exports.size32 = _favicon32x2.default;
	exports.icoFormat = _favicon2.default;
	exports.safariPinnedTab = _safariPinnedTab2.default;

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/safari-pinned-tab.e47a92e6.svg";

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgZmlsbD0iIzc0NGM5ZSIgd2lkdGg9IjEyMDBweCIgaGVpZ2h0PSIxMjAwcHgiIHZpZXdCb3g9IjAgMCAxMjAwIDEyMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyMDAgMTIwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggZD0iTTYwMCwyOC42NDRDMjg0LjQ0OSwyOC42NDQsMjguNjQ0LDI4NC40NDgsMjguNjQ0LDYwMGMwLDMxNS41NTMsMjU1LjgwNiw1NzEuMzU2LDU3MS4zNTYsNTcxLjM1Ng0KCQkJYzMxNS41NTMsMCw1NzEuMzU2LTI1NS44MDQsNTcxLjM1Ni01NzEuMzU2QzExNzEuMzU2LDI4NC40NDgsOTE1LjU1MywyOC42NDQsNjAwLDI4LjY0NHogTTE1MS40MTQsNjA1Ljk1Nmw0NDIuNjI5LDQ0Mi42Mw0KCQkJQzM1MC45ODksMTA0NS40MTgsMTU0LjU4MSw4NDkuMDEsMTUxLjQxNCw2MDUuOTU2eiBNNzAwLjQxNywxMDM3LjM3TDE2Mi42Myw0OTkuNTgzQzIwOC4yMzIsMzAwLjE0MiwzODYuNzM0LDE1MS4zMzksNjAwLDE1MS4zMzkNCgkJCWMxNDkuMDc3LDAsMjgxLjE0Nyw3Mi43MjcsMzYyLjczNCwxODQuNjE2bC02Mi4xMiw1NC44MTJDODM0LjQzMywyOTUuODU5LDcyNC40NzgsMjMzLjc0Niw2MDAsMjMzLjc0Ng0KCQkJYy0xNTguNDg1LDAtMjkzLjQ0NywxMDAuNjY4LTM0NC40NiwyNDEuNTQ1bDQ2OS4xNyw0NjkuMTdjMTEzLjkzOC00MS4yNiwyMDEuNTY2LTEzNy40NCwyMzAuOTE0LTI1Ni41Nkg3NjEuMTUydi04Ny45aDIwNS4xMDINCgkJCXYtMC4wMDJoODIuNDA3VjYwMEMxMDQ4LjY2MSw4MTMuMjY2LDg5OS44NTksOTkxLjc2OCw3MDAuNDE3LDEwMzcuMzd6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(107);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _index = __webpack_require__(181);
	
	var icons = _interopRequireWildcard(_index);
	
	var _meNp = __webpack_require__(168);
	
	var _meNp2 = _interopRequireDefault(_meNp);
	
	var _neocitiesLogo = __webpack_require__(501);
	
	var _neocitiesLogo2 = _interopRequireDefault(_neocitiesLogo);
	
	var _gatsbyLogo = __webpack_require__(500);
	
	var _gatsbyLogo2 = _interopRequireDefault(_gatsbyLogo);
	
	__webpack_require__(308);
	
	__webpack_require__(307);
	
	var _indexModule = __webpack_require__(303);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        titleTemplate: '%s - Patrick Canfield',
	        defaultTitle: 'Patrick Canfield',
	        meta: [{ name: 'description', content: 'Personal site of Patrick Canfield' }, { name: 'keywords', content: 'blog personal art technology philosophy food travel' }]
	      },
	      _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: icons.appleTouch }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: icons.size32 }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: icons.size16 }),
	      _react2.default.createElement('link', { rel: 'manifest', href: '/manifest.json?v=YAo0PGOwK0' }),
	      _react2.default.createElement('link', { rel: 'mask-icon', href: icons.safariPinnedTab, color: '#5bbad5' }),
	      _react2.default.createElement('link', { rel: 'shortcut icon', href: icons.icoFormat }),
	      _react2.default.createElement('link', { href: 'https://github.com/patreeceeo', rel: 'me' }),
	      _react2.default.createElement('meta', { name: 'apple-mobile-web-app-title', content: 'patreeceeo' }),
	      _react2.default.createElement('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' }),
	      _react2.default.createElement('meta', { name: 'application-name', content: 'patreeceeo' }),
	      _react2.default.createElement('meta', { name: 'theme-color', content: '#ffffff' }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: 'Personal site of Patrick Canfield' }),
	      _react2.default.createElement('meta', { name: 'twitter:creator', content: '@patreeceeo' }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: 'Personal site of Patrick Canfield' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: 'http://patrickcanfield.com/' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: 'http://patrickcanfield.com' + _meNp2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '1rem auto',
	          maxWidth: 800,
	          paddingLeft: '1rem',
	          paddingRight: '1rem'
	        }
	      },
	      children()
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.Footer },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://xn--sr8hvo.ws/\uD83D\uDC87/previous' },
	          '\u2190'
	        ),
	        'An IndieWeb Webring \uD83D\uDD78\uD83D\uDC8D site',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://xn--sr8hvo.ws/\uD83D\uDC87/next' },
	          '\u2192'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'When was the last time you played \u2014',
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/boggle' },
	              '\u2014 a puzzle?'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u2014 a platformer? (WIP)'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Proudly built with ',
	        _react2.default.createElement('img', { src: _gatsbyLogo2.default }),
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.gatsbyjs.org' },
	          'Gatsby'
	        ),
	        ' and hosted by ',
	        _react2.default.createElement('img', { src: _neocitiesLogo2.default }),
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://neocities.org/site/patrickcan' },
	          'Neocities'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'sub',
	            null,
	            'Copyright \xA9 2018 Patrick Canfield'
	          )
	        )
	      )
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Footer":"src-layouts----index-module---Footer---2OKdE"};

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-93918aea4dcfad1fea31.js